export enum ConfirmationModalResponse {
  CANCEL = 'cancel',
  CONFIRM = 'confirm',
}

export enum ModalCloseResponse {
  SUCCESS = 'success',
  ERROR = 'error',
  ABANDONED = 'abandoned',
}
